<template>
  <div class="today-call">
    <FilterHeader
      @search="search"
      @refresh="refresh"
    >
      <div class="call-pop-screen-filter-options">
        <div
          :class="['filter-option', { active: reqParam.is_ticket_submitted === undefined }]"
          @click="changeFilter()"
        >{{ $t('callPopScreen.allTickets') }}</div>
        <div
          :class="['filter-option', { active: reqParam.is_ticket_submitted === 1 }]"
          @click="changeFilter(1)"
        >{{ $t('callPopScreen.ticketRecorded') }}</div>
        <div
          :class="['filter-option', { active: reqParam.is_ticket_submitted === 0 }]"
          @click="changeFilter(0)"
        >{{ $t('callPopScreen.ticketUnrecorded') }}</div>
      </div>
    </FilterHeader>
    <div class="date-time-range">
      <el-date-picker
        v-model="reqTimeRange"
        type="datetimerange"
        align="right"
        size="small"
        unlink-panels
        :range-separator="$t('callPopScreen.to')"
        :start-placeholder="$t('callPopScreen.startDate')"
        :end-placeholder="$t('callPopScreen.endDate')"
        :default-time="['00:00:00', '23:59:59']"
        :picker-options="pickerOptions"
        @change="changeTime"
      >
      </el-date-picker>
    </div>
    <div class="call-list">
      <template v-if="isFinished && callList.length === 0">
        <div class="view-more">
          <div class="view-more-btn">{{ $t('callPopScreen.noRecords') }}</div>
        </div>
      </template>
      <template v-else>
        <CallInfoItem
          v-for="(item) in callList"
          :key="item.id"
          :item="item"
          listType="callHistory"
          @switchclient="onSwitchClient"
          :fieldMap="{
            cleId: 'cle_id',
            clePhone: 'cus_phone'
          }"
        />
        <div class="view-more">
          <div v-if="!isFinished" class="view-more-btn" @click="loadMore">{{isLoading ? $t('common.loading') : $t('callPopScreen.viewMore')}}</div>
          <div v-else class="view-more-btn">{{ $t('callPopScreen.noMore') }}</div>
        </div>
      </template>
    </div>
  </div>
</template>

<script>
import { getCdrList } from "@/api/ektv3";
import { mapGetters } from 'vuex';
import CallInfoItem from '../callInfoItem/index'
import FilterHeader from '../filterHeader'
import dayjs from 'dayjs';
import { getShortId } from '@/utils'
export default {
  props: {

  },
  data() {
    return {
      callList: [],
      isFinished: false,
      isLoading: false,
      reqParam: {},
      reqTimeRange: [],
      reqId: '',
      pickerOptions: {
        shortcuts: [{
          text: this.$t('callPopScreen.lastWeek'),
          onClick(picker) {
            const end = new Date();
            end.setHours(23, 59, 59, 999);  // 结束时间设置为当天最后时刻
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
            start.setHours(0, 0, 0, 0);     // 开始时间设置为当天零点
            picker.$emit('pick', [start, end]);
          }
        }, {
          text: this.$t('callPopScreen.lastMonth'),
          onClick(picker) {
            const end = new Date();
            end.setHours(23, 59, 59, 999);
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
            start.setHours(0, 0, 0, 0);
            picker.$emit('pick', [start, end]);
          }
        }, {
          text: this.$t('callPopScreen.lastThreeMonths'),
          onClick(picker) {
            const end = new Date();
            end.setHours(23, 59, 59, 999);
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
            start.setHours(0, 0, 0, 0);
            picker.$emit('pick', [start, end]);
          }
        }]
      },
    }
  },
  components: {
    CallInfoItem,
    FilterHeader
  },
  inject: ['curCall', 'setCurCall'],
  computed: {
    ...mapGetters(["userInfo"]),
    newCurCall() {
      return this.curCall()
    },
  },
  watch: {
    callList(arr) {
      const index = arr.findIndex(v => v.id === this.newCurCall.id)
      if(index !== -1) {
        const item = arr[index]
        this.setCurCall({
          itemType: this.newCurCall.itemType,
          id: item.id,
          cle_id: item.cle_id,
          cle_name: item.cle_name,
          cle_phone: item.cus_phone,
          call_id: item.call_id,
          call_type: item.call_type
        })
      }
    }
  },
  created() {
    this.reqTimeRange = this.getTime()
    this.reqParam = {
      ag_id: [this.userInfo.userId],
      start_time: dayjs(this.reqTimeRange[0]).format('YYYY-MM-DD HH:mm:ss'),
      end_time: dayjs(this.reqTimeRange[1]).format('YYYY-MM-DD HH:mm:ss'),
      page: 0,
      rows: 20,
      size: 20
    }
    this.reqId = getShortId()
    this.getCdrList(false, this.reqId)
    // 监听更新客户
    this._Bus.$on("updClient", this.updClient);
  },
  beforeDestroy() {
    this._Bus.$off("updClient", this.updClient)
  },
  methods: {
    getCdrList(isRefresh, reqId) {
      if(isRefresh) {
        this.isFinished = false
        this.reqParam.page = 0
        this.reqParam.rows = 20
        this.reqParam.size = 20
        this.callList = []
      }
      if(this.isFinished) return
      this.isLoading = true
      const { my: { ektv3_page }, } = this._config.URL;
      getCdrList(ektv3_page, { ...this.reqParam, page: this.reqParam.page + 1 }).then(res => {
        if(res.code === 0 && this.reqId === reqId) {
          this.reqParam.page++
          this.callList = [...this.callList, ...res.data.data]
          if(res.data.data.length < 20) {
            this.isFinished = true
          }
        }
      }).finally(() => {
        if(this.reqId === reqId) {
          this.isLoading = false
        }
      })
    },
    search(val) {
      const digits = (val || '').replace(/[^\d]/g, '')
      if(digits.length >= 7) {
        this.reqParam.cus_phone = digits
        delete this.reqParam.cle_name
      } else if(val && val.trim()) {
        this.reqParam.cle_name = val.trim()
        delete this.reqParam.cus_phone
      } else {
        delete this.reqParam.cus_phone
        delete this.reqParam.cle_name
      }
      this.reqId = getShortId()
      this.getCdrList(true, this.reqId)
    },
    refresh() {
      this.reqId = getShortId()
      this.getCdrList(true, this.reqId)
    },
    changeFilter(val) {
      this.reqParam.is_ticket_submitted = val
      this.reqId = getShortId()
      this.getCdrList(true, this.reqId)
    },
    loadMore() {
      this.reqId = getShortId()
      this.getCdrList(false, this.reqId)
    },
    getTime(type = 'last-week') {
      if(type === 'last-week') {
        const end = new Date();
        const start = new Date();
        start.setHours(0, 0, 0, 0);
        end.setHours(23, 59, 59, 999);
        start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
        return [start, end]
      }
    },
    changeTime(timeArr) {
      if(timeArr && timeArr.length) {
        this.reqParam.start_time = dayjs(timeArr[0]).format('YYYY-MM-DD HH:mm:ss')
        this.reqParam.end_time = dayjs(timeArr[1]).format('YYYY-MM-DD HH:mm:ss')
      } else {
        this.reqParam.start_time = undefined
        this.reqParam.end_time = undefined
      }
      this.reqId = getShortId()
      this.getCdrList(true, this.reqId)
    },
    onSwitchClient(item) {
      const index = this.callList.findIndex((v) => v.id === item.id)
      if(index !== -1) {
        const newItem = { ...this.callList[index], ...item }
        this.callList.splice(index, 1, newItem)
      }
    },
    updClient(clientInfo) {
      const item = {
        id: clientInfo.id,
        cle_id: clientInfo.cle_id,
        cle_name: clientInfo.cle_name,
        cus_phone: clientInfo.cle_phone
      }
      this.onSwitchClient(item)
    },
  }
}
</script>

<style lang="less" scoped>
.today-call {
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100%;
  .date-time-range {
    padding: 0 12px 8px;
    /deep/ .el-date-editor--datetimerange {
      width: 100%;
    }
  }
  .call-list {
    flex: 1;
    display: flex;
    flex-direction: column;
    overflow-y: auto;
    .view-more {
      flex-shrink: 0;
      display: flex;
      justify-content: center;
      align-items: center;
      width: 100%;
      height: 40px;
      color: #969799;
      font-size: 14px;
      &-btn {
        display: flex;
        align-items: center;
        height: 100%;
        cursor: pointer;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/view/Home/callPopScreenTab/callHistory/index.vue